/**
 * `DockZonePreview` — the **translucent dock-zone overlay** COMBAT paints while a
 * window is dragged to a workspace edge. {@link useCombatWindows} resolves the cursor's dock zone
 * to a screen-space card rect (`zonePreview`); this presentational component just renders that rect
 * as a ghost outline, so the user sees where a release will land (left half / right half / maximize)
 * before committing. Purely visual + click-through; the geometry decision is the pure
 * `resolveDockZone`/`zoneGeometry`.
 */
import type { Rect } from "./windowGeometry";

export function DockZonePreview({ rect }: { rect: Rect | null }) {
  if (!rect) return null;
  return (
    <div
      className="gms-dockzone"
      aria-hidden="true"
      style={{ left: rect.x, top: rect.y, width: rect.w, height: rect.h }}
    />
  );
}
